import * as React from 'react';
import useTranslation from '../../../../../translation/hooks/UseTranslation';
var ButtonImplementation = function (_a) {
    var style = _a.style, className = _a.className, onPress = _a.onPress, disabled = _a.disabled, children = _a.children, noTranslation = _a.noTranslation, testId = _a.testId, value = _a.value;
    var t = useTranslation().t;
    return (React.createElement("button", { "data-testid": testId, type: "button", style: style, className: className, onClick: onPress, disabled: disabled, value: value }, noTranslation ? children : t(children)));
};
export default ButtonImplementation;
//# sourceMappingURL=ButtonImplementation.js.map